let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gvE0V")).then(() => parcelRequire('4Pup2'));